import Toasted from 'vue-toasted';
import Vue from 'vue';
import HtmlFormatter from '@/shared/services/htmlFormatter';

Vue.use(Toasted);

export default class Toast {
	public static showSuccess(message: string): void {
		Vue.toasted.show(HtmlFormatter.escapeHtmlCharacters(message), {
			position: 'bottom-center',
			duration: 3000,
			className: 'toast-success'
		});
	}

	public static showError(message: string): void {
		Vue.toasted.show(HtmlFormatter.escapeHtmlCharacters(message), {
			position: 'bottom-center',
			duration: 3000,
			className: 'toast-error'
		});
	}

	public static showInfo(message: string): void {
		Vue.toasted.show(HtmlFormatter.escapeHtmlCharacters(message), {
			position: 'bottom-center',
			duration: 3000,
			className: 'toast-info'
		});
	}
}
